export class LocalizationForm extends HTMLElement {
  protected elements: {
    input: HTMLInputElement | null;
    button: HTMLElement | null;
    panel: HTMLElement | null;
  };

  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button?.addEventListener(
      'click',
      this.openSelector.bind(this)
    );
    this.elements.button?.addEventListener(
      'focusout',
      this.closeSelector.bind(this)
    );
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach((item) =>
      item.addEventListener('click', this.onItemClick.bind(this))
    );
  }

  hidePanel(): void {
    if (this.elements.button && this.elements.panel) {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', 'true');
    }
  }

  onContainerKeyUp(event: KeyboardEvent): void {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    if (this.elements.button) {
      this.elements.button.focus();
    }
  }

  onItemClick(event: MouseEvent): void {
    event.preventDefault();
    const form = this.querySelector('form');
    if (
      this.elements.input &&
      event.currentTarget &&
      event.currentTarget instanceof HTMLElement
    ) {
      this.elements.input.value = event.currentTarget.dataset.value || '';
    }
    if (form) {
      form.submit();
    }
  }

  openSelector(): void {
    if (!this.elements.button || !this.elements.panel) {
      return;
    }

    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute(
      'aria-expanded',
      (
        this.elements.button.getAttribute('aria-expanded') === 'false'
      ).toString()
    );
  }

  closeSelector(event: FocusEvent): void {
    const shouldClose =
      event.relatedTarget && event.relatedTarget instanceof HTMLButtonElement;
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
